import { Form, InputNumber, Select, Spin } from 'antd';
import { FormComponentProps } from 'antd/lib/form/Form';
import React from 'react';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import Swal from 'sweetalert2';
import FormHeader from '../../components/Form/Header';
import RoutesEndpoint from '../../core-module/models/LoopBack/Models/RoutesEndpoint';
import { RouteDeclarationFormInformation } from '../../core-module/models/redux/DefaultRouteState';
import { defaultTableState } from '../../core-module/models/redux/DefaultTableState';
import { fetchRouteDeclarationFormInformation } from '../../core-module/redux/Route/actions';
import { fetchTable, setLoading } from '../../core-module/redux/Table/actions';
import { AppState } from '../../core-module/redux/reducers';

interface Props extends FormComponentProps {
  rowData: any;
  stateKey: number | string;
  state: typeof defaultTableState;
  fetchTable: (stateKey, endPoint, filters) => void;
  setLoading: (stateKey, loading) => void;
  loopBackEndpoint: RoutesEndpoint;
  dispatch: Dispatch;
  type: string;
  declarationFormInformation?: RouteDeclarationFormInformation;
  isLoading: boolean;
}

class RouteForm extends React.Component<Props> {
  objectId: number;

  constructor(props) {
    super(props);
    const { loopBackEndpoint, rowData } = this.props;

    this.objectId = -1;

    if (rowData) {
      this.objectId = rowData[loopBackEndpoint.getIndexKey()];
    }
  }

  componentDidMount() {
    if (!this.props.isLoading && !this.props.declarationFormInformation) {
      this.props.dispatch(fetchRouteDeclarationFormInformation());
    }
  }

  performAction(fieldNames) {
    const { form, state, stateKey } = this.props;
    const changed = form.getFieldsValue(['actual_driven_km', 'comments', 'temperature']);

    if (this.props.type === 'edit') {
      this.props.loopBackEndpoint
        .update(changed, this.props.rowData)
        .then((res) => {
          this.props.dispatch(setLoading(stateKey, true));
          this.props.dispatch(fetchTable(stateKey, 'routes/by-user', state.filters));

          Swal({
            title: 'Kilometers doorgegeven',
            text: `De kilometers zijn succesvol opgeslagen`,
            type: 'success',
            confirmButtonText: 'Ok'
          }).then((result) => {});
        })
        .catch(() => {
          setLoading(stateKey, false);
          Swal({
            title: 'Helaas',
            text: `Er is iets mis gegaan bij het opslaan van de kilometers`,
            type: 'error',
            confirmButtonText: 'Ok'
          }).then((result) => {});
        });
    }
  }

  validateActualDrivenKm = (_, value) => {
    const { kmRangeUntilReasonRequired, maxKmRange } = this.props.declarationFormInformation!;

    if (
      this.validateActualDrivenKmValues(value) &&
      this.props.form.getFieldsValue().comments === undefined
    ) {
      return Promise.reject(
        `Ingevoerde kilometers wijken meer dan ${kmRangeUntilReasonRequired} km af van berekende route, licht afwijking toe in de opmerking!`
      );
    } else if (value > +this.props.rowData.total_km + maxKmRange) {
      return Promise.reject(
        `Ingevoerde kilometers wijken meer dan ${maxKmRange} km af van berekende route, dit is niet toegestaan!`
      );
    }

    return Promise.resolve();
  };

  validateComments = (_) => {
    if (
      this.validateActualDrivenKmValues(this.props.form.getFieldsValue().actual_driven_km) &&
      this.props.form.getFieldsValue().comments === undefined
    ) {
      return Promise.reject(
        'Voor deze afwijking in het aantal kilometers is het verplicht om commentaar in te vullen.'
      );
    }

    return Promise.resolve();
  };

  validateActualDrivenKmValues(value: number): boolean {
    const { kmRangeUntilReasonRequired, maxKmRange } = this.props.declarationFormInformation!;
    return (
      value > +this.props.rowData.total_km + kmRangeUntilReasonRequired &&
      value < +this.props.rowData.total_km + maxKmRange
    );
  }

  validate = () => {
    this.props.form.validateFields(['actual_driven_km', 'comments', 'temperature']);
  };

  render() {
    const { getFieldDecorator } = this.props.form;

    const formItemLayout = {
      style: { marginTop: 20 },
      labelCol: {
        xs: { span: 24 },
        sm: { span: 8 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 }
      }
    };

    if (!this.props.declarationFormInformation) {
      return (
        <span>
          <Spin spinning={true} /> <em> Kilometerdeclaratie formulier aan het laden...</em>
        </span>
      );
    }

    return (
      <div>
        <FormHeader
          type={this.props.type}
          newTitle={'Kilometers doorgeven'}
          editTitle={`Kilometers doorgeven`}
        />
        <Form {...formItemLayout}>
          <Form.Item label={'Gereden kilometers'}>
            {getFieldDecorator('actual_driven_km', {
              rules: [
                { required: true, message: 'Voer de gereden kilometers in' },
                { validator: this.validateActualDrivenKm }
              ],
              initialValue:
                this.props.type === 'edit' && this.props.rowData.actual_driven_km
                  ? this.props.rowData.actual_driven_km
                  : undefined
            })(
              <InputNumber
                style={{ width: '100%' }}
                min={0}
                decimalSeparator={','}
                precision={1}
                step={0.1}
                onBlur={this.validate}
              />
            )}
          </Form.Item>

          <Form.Item
            label='Temperatuurmeting'
            extra={
              'Voer alleen een temperatuurmeting in als je een gekalibreerde thermometer van Uitgekookt hebt ontvangen.'
            }
          >
            {getFieldDecorator('temperature', {
              rules: [{ required: false }],
              initialValue:
                this.props.type === 'edit' && this.props.rowData.temperature
                  ? this.props.rowData.temperature
                  : undefined
            })(
              <InputNumber
                style={{ width: '100%' }}
                min={0}
                decimalSeparator={','}
                precision={1}
                step={0.1}
              />
            )}
          </Form.Item>
          <Form.Item
            label={'Opmerkingen'}
            extra={
              'Voer alleen opmerkingen mbt de gereden kilometers. Voor overige opmerkingen mail ons op maaltijdservice@uitgekookt.nl'
            }
          >
            {getFieldDecorator('comments', {
              rules: [{ required: false }, { validator: this.validateComments }],
              initialValue:
                this.props.type === 'edit' && this.props.rowData.comments
                  ? this.props.rowData.comments
                  : undefined
            })(
              <Select allowClear={true} onBlur={this.validate}>
                {this.props.declarationFormInformation.commentOptions.map((r) => (
                  <Select.Option value={r}>{r}</Select.Option>
                ))}
              </Select>
            )}
          </Form.Item>
        </Form>
      </div>
    );
  }
}

const mapStateToProps = ({ table, auth, routes }: AppState, props) => {
  return {
    state: table.tables[props.stateKey],
    declarationFormInformation: routes.declarationFormInformation,
    isLoading: routes.loadingDeclarationFormInformation
  };
};

export default connect(mapStateToProps)(Form.create()(RouteForm));
